import React, { useState, useRef } from "react";
import { Box, Button, Divider, Typography } from "@mui/material";
import "react-medium-image-zoom/dist/styles.css";
// import "../../JaldiLab.css";
import "./JaldiLab.css";
import {
  dimensionStyle,
  generateOrderedList,
  getCircleTypeListItemCustom,
  getTextContentWithHeading,
  getTextNestedList,
  h1style,
  h3style,
  orderedListWithItem,
  referenceStyle,
  referenceTootKit,
  sectionStyle,
  subHeadingContent,
  tableCaption,
} from "./Chapters/ChapterList";

import SecurityModuleTable from "../Impact/SecurityModuleTable";
import {
  VWDCTableData,
  accussedTableData,
  advocateTableData,
  airNoiseTable,
  annexureSevenData,
  applicationDev,
  associatedTools,
  authorsTable,
  courtTableData,
  judgeTableData,
  litigantsTableData,
  mechanicalNoiseTable,
  wallsTable,
} from "../../utils/ProcessModuleData";
import ProcessModuleTable from "./ProcessModuleTable";
import AnnexureTable from "./AnnexureTable";
import CustomTable from "./CustomTable";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { styled } from "@mui/material/styles";
import CaptionWithBorders1 from "../../components/ChapterImage/Image";
import designConsideration from "../../assets/SvgIcons/design-consideration.svg";
import renderCourtroom from "../../assets/Images/Annexure Images/Render_Courtroom.png";
import ceilingAccoustic from "../../assets/Images/Annexure Images/CeilingAccoustics.png";
import annexure9Img from "../../assets/Images/Annexure Images/annexure9.png";
import sourceOfNoise from "../../assets/Images/Annexure Images/sourceOfNoise.png";
import strongBunker from "../../assets/Images/Annexure Images/Strong_Room.jpeg";
import boomBarrier2 from "../../assets/Images/Annexure Images/BoomBarriers_2.jpg";
import doorFrame from "../../assets/Images/Annexure Images/DoorFrame.png";
import fullBodyScanner from "../../assets/Images/Annexure Images/fullBodyScanner.png";
import baggageScanner from "../../assets/Images/Annexure Images/baggageScanner.jpg";
import turnStileImg from "../../assets/Images/Annexure Images/Turnstile_IndiaMART.png";
import midDotImg from "../../assets/Images/Annexure Images/MidDotAutomation.png";
import secureScanner from "../../assets/Images/Annexure Images/securscan-mion.jpg";
import ipEmergency from "../../assets/Images/Annexure Images/IPEmergency_Communication.jpg";
import parkingManagement from "../../assets/Images/Annexure Images/parking-management-system.gif";
import visitorManagement from "../../assets/Images/Annexure Images/Visitor-Management-System.jpg";
import publicAddressSystem from "../../assets/Images/Annexure Images/Public-Address-System.jpg";
import rfid from "../../assets/Images/Annexure Images/RFID.jpeg";
import biometricAccessControl from "../../assets/Images/Annexure Images/BiometricAccessControl.jpeg";
import irisSourceSecurity from "../../assets/Images/Annexure Images/IRIS_SourceSecurity.jpg";
import leoSystem from "../../assets/Images/Annexure Images/Leo3Systems.png";
import survillenceSystem from "../../assets/Images/Annexure Images/Surveillance-System.jpeg";
import notificationSystem from "../../assets/Images/Annexure Images/notificationSystem.png";
import massNotificationImg from "../../assets/Images/Annexure Images/massNotificationImg.png";
import kioskImg from "../../assets/Images/Annexure Images/kioskImg.png";
import kioskImg2 from "../../assets/Images/Annexure Images/kioskImg2.png";
import dataRoomCompanyImg from "../../assets/Images/Annexure Images/DataRoomCompany.jpeg";
import breifCaseImg from "../../assets/Images/Annexure Images/BallisticBriefcase.jpeg";
import ceilingImg2 from "../../assets/Images/Annexure Images/ceilingImg2.jpg";
import ceilingImg1 from "../../assets/Images/Annexure Images/ceilingImg1.webp";
import perforatedWall from "../../assets/Images/Annexure Images/Perforated-wall.jpg";
import ceilingTiles from "../../assets/Images/Annexure Images/ceiling-tiles.jpg";
import spaceVolume from "../../assets/Images/Annexure Images/spaceVolume.png";
import slottedWooden from "../../assets/Images/Annexure Images/slottedWooden.jpeg";
import laminatedWooden from "../../assets/Images/Annexure Images/laminatedWooden.jpeg";
import AnnexureSevenTable from "./Chapters/Common/AnnexureSevenTable";
import CaptionWithBorders2 from "../../components/ChapterImage/CaptionWithBorder2";
import { FigureDesc77, FigureDesc78, ImageDesc113, ImageDesc114, ImageDesc115, ImageDesc116, ImageDesc117, ImageDesc118, ImageDesc119, ImageDesc120, ImageDesc121, ImageDesc122, ImageDesc123, ImageDesc124, ImageDesc125, ImageDesc126, ImageDesc127, ImageDesc128, ImageDesc129, ImageDesc130, ImageDesc131, ImageDesc132, ImageDesc133, ImageDesc134, ImageDesc135, ImageDesc136, ImageDesc137, ImageDesc138, ImageDesc139, ImageDesc140, ImageDesc141 } from "../../utils/tmp/ImageDescription/AnnexureReadingID";
import useCustomLogic from "../../Hooks/UseCustomLogic";

const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  "& .MuiAccordionSummary-content": {
    margin: "0 !important",
  },
  "& .Mui-expanded": {
    margin: theme.spacing(0),
  },
}));

const AnnexureReading = () => {
  const [expanded, setExpanded] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const referencesRef = useRef(null);
  const panel1Ref = useRef(null);
  const panel2Ref = useRef(null);
  const panel3Ref = useRef(null);
  const panel4Ref = useRef(null);
  const panel5Ref = useRef(null);
  const panel6Ref = useRef(null);
  const panel7Ref = useRef(null);
  const panel8Ref = useRef(null);
  const panel9Ref = useRef(null);
  const { isXs, isSm } = useCustomLogic();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };
  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };

  const referenceHtml = (stringsArray) => {
    return (
      <ol>
        {stringsArray.map((text, index) => (
          <li style={{ ...pointStyle, paddingLeft: "10px" }} key={text.content}>
            {text.content}
            {text?.link && (
              <a
                style={{
                  color: "#DC002D",
                  textDecoration: "none",
                }}
                href={text.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {text.description}
              </a>
            )}
          </li>
        ))}
      </ol>
    );
  };

  const referenceData = [
    {
      content:
        "‘DIN 18041 Acoustic quality in rooms - Specifications and instructions for the room acoustic design’ ",
      link: "https://www.en-standard.eu/din-18041-acoustic-quality-in-rooms-specifications-and-instructions-for-the-room-acoustic-design/",
      description:
        "<https://www.en-standard.eu/din-18041-acoustic-quality-in-rooms-specifications-and-instructions-for-the-room-acoustic-design/> ",
    },
    {
      content:
        "Christian Nocke and Akustikbüro Oldenburg, ‘DIN 18041 - a German View’ (Euronoise 2018) ",
      link: "https://www.euronoise2018.eu/docs/papers/176_Euronoise2018.pdf",
      description:
        "<https://www.euronoise2018.eu/docs/papers/176_Euronoise2018.pdf>",
    },
    {
      content:
        "Acoustic wall panelling can be provided from a  height of 3- 4 feet to mitigate any maintenance issues.",
    },
    {
      content:
        "‘ASHRAE Handbook HVAC Applications, Chapter 48: Noise and Vibration Control’ ",
      link: "https://www.ashrae.org/advertising/handbook-advertising/applications/noise-and-vibration-control",
      description:
        " <https://www.ashrae.org/advertising/handbook-advertising/applications/noise-and-vibration-control>",
    },
    {
      content:
        "‘ASHRAE Handbook HVAC Applications, Chapter 48: Noise and Vibration Control’, Table 1 ",
      link: "https://www.ashrae.org/advertising/handbook-advertising/applications/noise-and-vibration-control",
      description:
        "<https://www.ashrae.org/advertising/handbook-advertising/applications/noise-and-vibration-control> ",
    },
    {
      content:
        "The standards given are in terms of the sound transmission class (“STC”)  which is defined as an integer rating of how well a building partition attenuates airborne sound and are based on the laboratory measurement. The quoted standards are equally applicable to walls and floors.",
    },
    {
      content:
        "Any other construction can be explored based on the availability and site requirement satisfying the acoustic requirements.",
    },
    {
      content: " ‘Agreement for Facility Management Contractor's Services’ ",
      link: "https://www.nhdc.org.in/Upload/Tender/RevisedServiceAgreementFMCDHSVaranasi.pdf",
      description:
        "<https://www.nhdc.org.in/Upload/Tender/RevisedServiceAgreementFMCDHSVaranasi.pdf>",
    },
    {
      content:
        " Naya Raipur Development Authority, 'Request for Proposal: For Selection of a Facility Management Service Provider for Paryavas Bhawan and Its Campus at Sector 19, Naya Raipur' (RFP No: 120  / FMS PB/ RFP/CE(E)/NRDA/2016-17, Naya Raipur dated 20 /10/ 2016) ",
      link: "https://navaraipuratalnagar.com/NRDARevampTheme/archive/RFP-Facility-Management-29102016.pdf",
      description:
        "<https://navaraipuratalnagar.com/NRDARevampTheme/archive/RFP-Facility-Management-29102016.pdf> ",
    },
    {
      content:
        " ‘Tender for Facility Management Services At Rajiv Gandhi National Institute of Intellectual Property Management/Patent Information System (RGNIIPM/PIS), Nagpur’ ",
      link: "https://ipindia.gov.in/writereaddata/Portal/News/64_1_26-fms-nagpur-19aug2015.pdf",
      description:
        "<https://ipindia.gov.in/writereaddata/Portal/News/64_1_26-fms-nagpur-19aug2015.pdf>",
    },
    {
      content:
        "‘RFP for Engagement of Outsourcing Agency for Up-Keeping, Cleaning & Maintenance and Electrical Services in District Court Complex, Rayagada and Taluk Court Complexes-Gunupur, Bissamcuttack & Kashipur, for the Year 2022-23’",
      link: "https://districts.ecourts.gov.in/sites/default/files/Invitation%20of%20Bids%20for%20Rayagada.pdf",
      description:
        "<https://districts.ecourts.gov.in/sites/default/files/Invitation%20of%20Bids%20for%20Rayagada.pdf>",
    },
    {
      content:
        " Odisha Computer Application Centre, Technical Directorate of E&IT Department, Govt. of Odisha ‘Revised request for Proposal: OSDC 2.0 -Extension of Odisha State Data Centre’ ",
      link: "https://odisha.gov.in/sites/default/files/2021-01/RFP-20038_28.01.2021.pdf",
      description:
        "<https://odisha.gov.in/sites/default/files/2021-01/RFP-20038_28.01.2021.pdf>",
    },
    {
      content: "High Court of Orissa, Annual Report 2022, pg. 39.",
    },
  ];

  // annexure 1 table header
  const annexureHeaderOne = [
    "SI. No.",
    "Case example",
    "Context- Sensitive Building Design (Building Design)",
    "Sustainable Site Planning (Site Design)",
    "Passive Design Strategies (Building Design)",
    "Active Design Strategies (Building Design)",
    "Green Building Materials and Finishes (Building Design)",
    "Carbon Reduction and Energy Efficiency (Building Design)",
    "Water Management (Site design)",
    "Native Species for Landscaping (Site design)",
  ];
  // annexure 2 table header
  const annexureHeaderTwo = [
    "Zones",
    "Name",
    "Potential Possibilities",
    "Actionable Components",
  ];
  // annexure 1 table data
  const annexureRowOne = [
    {
      sno: "1.",
      data1: "Delhi High Court Extension Building, Delhi",
      data2: (
        <>
          <p>Complements existing Delhi High Court .</p>
          <p> Urban context integration</p>
        </>
      ),
      data3: "Functionally optimised layout",
      data4: (
        <>
          <p>Passive solar design.</p>
          <p> Natural ventilation.</p>
          <p> Energy-efficient glazing</p>
        </>
      ),
      data5: "Advanced building management systems",
      data6: "Low-VOC paints",
      data7: (
        <>
          <p>Energy-efficient HVAC systems.</p>
          <p> Solar panels.</p>
          <p> Green materials.</p>
        </>
      ),
      data8: (
        <>
          <p>Rain water harvesting (RWH).</p>
          <p> Efficient drainage system</p>
        </>
      ),
      data9: "Indigenous plants for landscaping",
    },
    {
      sno: "2.",
      data1: "National Judicial Academy, at Bhopal",
      data2: (
        <>
          <p>
            Incorporation of local architectural elements and cultural
            considerations.{" "}
          </p>
          <p>
            Architectural design tailored to the specific context and
            surroundings of Bhopal.
          </p>
        </>
      ),
      data3: (
        <>
          <p>
            Environmentally conscious site layout to minimise ecological impact.
          </p>
          <p> Preserving natural features and habitats during construction.</p>
        </>
      ),
      data4: (
        <>
          <p>
            Utilisation of natural elements like sunlight and wind for heating,
            cooling, and ventilation.
          </p>
          <p>
            {" "}
            Building orientation to optimise natural light and reduce the need
            for artificial lighting.
          </p>
        </>
      ),
      data5: (
        <>
          <p>
            Integration of technology and active systems for efficient heating,
            cooling, and lighting.
          </p>
          <p>
            {" "}
            Smart building controls for optimising energy usage based on
            occupancy and usage patterns.
          </p>
        </>
      ),
      data6: (
        <>
          <p>
            Use of eco-friendly and sustainable materials for construction and
            interior finishes.
          </p>
          <p>
            {" "}
            Implementation of recycling and waste reduction practices during
            material selection and installation.
          </p>
        </>
      ),
      data7: (
        <>
          <p>
            Implementation of energy-efficient HVAC systems and lighting
            solutions.{" "}
          </p>
          <p>
            Integration of renewable energy sources like solar panels to reduce
            carbon footprint.
          </p>
        </>
      ),
      data8: (
        <>
          <p>
            Adoption of water-saving fixtures and technologies to minimise water
            consumption.{" "}
          </p>
          <p>
            Implementation of rainwater harvesting and wastewater recycling
            systems.
          </p>
        </>
      ),
      data9: (
        <>
          <p>
            Planting native vegetation for landscaping to promote biodiversity
            and ecosystem health.
          </p>
          <p>
            {" "}
            Utilisation of drought-resistant plants to reduce water requirements
            for landscaping.
          </p>
        </>
      ),
    },
    {
      sno: "3.",
      data1: "Khunti District Court, Net-Zero Energy Court Complex, Jharkhand",
      data2: (
        <>
          <p>Incorporation of local architectural elements.</p>
          <p> Culturally relevant materials.</p>
        </>
      ),
      data3: (
        <>
          <p>Energy-efficient layout.</p>
          <p> Landscaping with native flora.</p>
          <p> Sustainable water management.</p>
        </>
      ),
      data4: (
        <>
          <p>Orientation for natural lighting.</p>
          <p> Shading for cooling.</p>
          <p> Thermal insulation.</p>
          <p> Use of shading devices.</p>
          <p> Natural ventilation systems.</p>
        </>
      ),
      data5: "-",
      data6: (
        <>
          <p>Use of sustainable materials.</p>
          <p> Low VOC finishes.</p>
        </>
      ),
      data7: (
        <>
          <p>Solar panels for net-zero energy.</p>
          <p> Energy-efficient HVAC systems.</p>
          <p> LED lighting.</p>
        </>
      ),
      data8: (
        <>
          <p>Rain water harvesting(RWH).</p>
          <p> Efficient drainage system</p>
        </>
      ),
      data9: (
        <>
          <p>Use of native plants.</p>
          <p> Drought-resistant landscaping.</p>
        </>
      ),
    },
    {
      sno: "4.",
      data1: "National Green Tribunal Building, New Delhi",
      data2: (
        <>
          <p>Integration with urban surroundings.</p>
          <p> Climate-responsive design.</p>
        </>
      ),
      data3: "Optimised site planning",
      data4: (
        <>
          <p>Natural ventilation.</p>
          <p> Daylight harvesting.</p>
          <p> Facade design for shading.</p>
          <p> Green roof. Green spaces on each floor. </p>
        </>
      ),
      data5: "-",
      data6: (
        <>
          <p>Recycled and sustainable materials.</p>
          <p> Low-emission paints.</p>
        </>
      ),
      data7: (
        <>
          <p>Efficient lighting. HVAC systems.</p>
          <p> Green building materials.</p>
        </>
      ),
      data8: (
        <>
          <p>Efficient stormwater management.</p>
          <p> Rain gardens.</p>
        </>
      ),
      data9: (
        <>
          <p>Use of indigenous plants.</p>
          <p> Sustainable landscaping.</p>
        </>
      ),
    },
    {
      sno: "5.",
      data1: "Surat District Court Complex, Gujarat",
      data2: "Design considerations for Surat's climate and culture.",
      data3: "Sustainable land use planning",
      data4: (
        <>
          <p>Natural ventilation.</p>
          <p> Daylighting.</p>
          <p> Thermal comfort design.</p>
        </>
      ),
      data5: (
        <>
          <p>Occupancy sensors for lighting.</p>
          <p> Facade shading.</p>
        </>
      ),
      data6: (
        <>
          <p>Energy-efficient HVAC and lighting.</p>
          <p> Green building materials.</p>
        </>
      ),
      data7: (
        <>
          <p>Green building materials.</p>
          <p> Low-toxicity finishes.</p>
        </>
      ),
      data8: (
        <>
          <p>Sustainable rain gardens.</p>
          <p> Pervious pavers.</p>
        </>
      ),
      data9: "Native species for low-maintenance landscaping.",
    },

    {
      sno: "6.",
      data1: "Kochi International Arbitration Centre, Kerala",
      data2: (
        <>
          <p>Incorporates the traditional architecture of Kerala.</p>
          <p> Tropical climate responsiveness.</p>
        </>
      ),
      data3: (
        <>
          <p>Sustainable site development.</p>
          <p> Rainwater harvesting.</p>
          <p> Native plant landscaping.</p>
        </>
      ),
      data4: (
        <>
          <p>Natural ventilation.</p>
          <p> Passive cooling</p>
          <p> Green roof.</p>
        </>
      ),
      data5: (
        <>
          <p>Energy-efficient lighting control.</p>
          <p> Smart HVAC systems..</p>
        </>
      ),
      data6: (
        <>
          <p>Use of eco-friendly materials.</p>
          <p> Low-impact finishes.</p>
        </>
      ),
      data7: (
        <>
          <p>Energy-efficient lighting.</p>
          <p> HVAC systems.</p>
          <p> Sustainable waste management.</p>
        </>
      ),
      data8: "Efficient storm water management.",
      data9: "Native flora for sustainable landscaping.",
    },
    {
      sno: "7.",
      data1: "Sikkim High Court, Gangtok",
      data2: (
        <>
          <p>Blends with the natural landscape.</p>
          <p> Local building techniques.</p>
        </>
      ),
      data3: "Efficient site planning to minimise environmental impact",
      data4: (
        <>
          <p>Passive cooling techniques.</p>
          <p> Efficient windows.</p>
          <p> Insulation.</p>
        </>
      ),
      data5: (
        <>
          <p>Advanced HVAC control systems.</p>
          <p> Solar shading.</p>
        </>
      ),
      data6: (
        <>
          <p>Use of local materials.</p>
          <p> Low-impact finishes.</p>
        </>
      ),
      data7: (
        <>
          <p>Energy-efficient HVAC systems.</p>
          <p> Sustainable construction materials.</p>
        </>
      ),
      data8: "Sustainable stormwater infrastructure",
      data9: (
        <>
          <p>Use of native plants.</p>
          <p> Biodiversity-rich landscaping.</p>
        </>
      ),
    },
  ];
  // annexure 2 table data
  const annexureRowTwo = [
    {
      sno: "1.",
      data1: "Neighborhood",
      data2: (
        <ul>
          <li>
            Building block layout, aesthetic, and public use communications /
            wayfinding signages are all included in site treatments.
          </li>
          <li>
            Effective neighbourhood-based solutions include operational security
            and traffic guidance/control measures.
          </li>
        </ul>
      ),
      data3: (
        <ul>
          <li>
            Coordinate with existing and proposed development plans, policies,
            and initiatives
          </li>
          <li>Collaborate with other local security initiatives</li>
          <li> Modify the flow of traffic </li>
          <li>
            Take into account incorporating a standoff zone with public
            right-of-way. Develop and coordinate personal safety programmes.{" "}
          </li>
          <li>
            {" "}
            If necessary, consider closing all or a portion of an existing
            street. Install temporary barriers for higher levels of alert.
          </li>
        </ul>
      ),
    },
    {
      sno: "2.",
      data1: "Standoff Perimeter",
      data2:
        "It is possible to serve the needs of the standoff while improving the site's functionality and attractiveness for the general public, employees, and visitors.",
      data3: (
        <ul>
          <li>
            Establish the necessary level of protection based on the risk that
            is acceptable.
          </li>
          <li>Determine the location and size of the standoff zone.</li>
          <li>
            {" "}
            Where necessary, create a hardened perimeter using the following:
            Bollards, walls, hardened street furniture, fences, topography, dry
            moats, collapsible surfaces, sculptures or sitting obstacles, plants
            / hedges/ landscaping or other appropriate barriers.{" "}
          </li>
        </ul>
      ),
    },
    {
      sno: "3.",
      data1: "Site Access and Parking",
      data2:
        "Ensuring security for the premises can also facilitate efficient access, passive observation, and improved user convenience.",
      data3: (
        <ul>
          <li> Identify & define drop-off and pickup locations</li>
          <li>
            {" "}
            Limit access to the premises by including: Inspection zones;
            retractable bollards; gates, guard posts, and Toby Ports
          </li>
          <li>Supervise the loading and service areas</li>
          <li>Provide open access points for emergency personnel</li>
          <li>Create distinct pedestrian traffic routes</li>
          <li>
            Create secure parking spaces (parking garage, cellar parking,
            surface-level parking) both inside and outside the standoff zone
            including signage, lighting, and wayfinding.
          </li>
        </ul>
      ),
    },
    {
      sno: "4.",
      data1: "Site",
      data2:
        "Added protection, safety, and comforts may be provided by site elements including reflecting ponds, seats, and security pavilions on the property and inside the standoff zone border.",
      data3: (
        <ul>
          <li>
            Create security structures and other standalone structures that
            complement the architectural style of the site.{" "}
          </li>
          <li>
            Design multipurpose site amenities, including furniture, planters,
            water features, lighting, and flora.
          </li>
          <li>Set aside a covered area for lines at entrances.</li>
        </ul>
      ),
    },
    {
      sno: "5.",
      data1: "Building Envelope",
      data2:
        "The site's overall safety could be improved with security measures.",
      data3: (
        <ul>
          <li>Designing the building to minimise the impact of explosions</li>
          <li>
            Plan emergency exits that make evacuating a building faster &
            efficient.
          </li>
          <li>Restrict entry to vents and air intakes.</li>
          <li>Position cameras and lighting to improve visibility.</li>
          <li>Strengthen the framework and exterior of the building</li>
        </ul>
      ),
    },
    {
      sno: "6.",
      data1: "Management and Building Operations",
      data2:
        "Without affecting the site itself, improvements to space planning and building operations may minimise certain risks.",
      data3: (
        <ul>
          <li>Plan the buildings and spaces with flexibility in mind.</li>
          <li>
            {" "}
            If there are site or financial limitations, take into account guards
            and alternative security activities.
          </li>
          <li>
            If it is neither practicable nor reasonable to protect site elements
            or a facility's exterior, choose to do nothing to mitigate the risk
            instead of accepting it.
          </li>
        </ul>
      ),
    },
  ];

  // boom barrier table data
  const boomBarrierDataHeader = [
    "",
    "Pictorial Representation",
    "Functional Requirements",
    "",
  ];

  const stakeholderItem = [
    "Members of the judicial system such as Judges, staff and advocates,",
    "Accused Persons & Vulnerable witnesses (separately), and",
    "general occupants of the space.",
  ];

  const safetySystemItem = [
    "CCTV with Video Management System for situational awareness",
    "Public Address System for guidance and precise communication",
    "Mode-change of Access Control system to redirect the occupants away from the threat or area of potential risk / incident.",
  ];

  const boomBarrierData = [
    {
      subHeading: [
        {
          sno: "3.1.",
          title: "Physical Security",
        },
        {
          sno: "1.",
          title: "Boom Barriers",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[boomBarrier2]}
              caption={"Image 113: Example of a Boom Barrier"}
              creditLabel="Image Credit"
              imageCredit="Instamart - Creative Commons Image"
              imageDescription={ImageDesc113}
            />
          ),
          functional: (
            <>
              <p>
                The functional requirements of the Boom Barrier are to ensure
                that all authorised vehicles punch in their entry time or are
                tagged in based on the security check at the entrance.
              </p>
              <p>
                Based on the privilege and the security location designated for
                the user, the path would be determined, and the Boom Barrier
                will determine clearance for entry.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "2.",
          title: "Full Body Scanner ",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <>
              {" "}
              <CaptionWithBorders1
                image={[doorFrame]}
                caption={"Image 114: Example of a Door Frame Metal Detector"}
                creditLabel="Image Credit"
                imageCredit="Security Control Systems India"
                zoomImgStyle={{ height: "400px" }}
                imageDescription={ImageDesc114}
              />
              <CaptionWithBorders1
                image={[fullBodyScanner]}
                caption={"Image 115: Example of a Full Body Scanner"}
                creditLabel="Image Credit"
                imageCredit="ProVision ATD"
                zoomImgStyle={{ height: "400px" }}
                imageDescription={ImageDesc115}
              />
            </>
          ),
          functional: (
            <>
              <p>
                The Full-Body Scanner should be of two variants:
                <ul>
                  <li>
                    Low-Sensitivity Scanner to be deployed along the boundaries
                    of the perimeter space for creation of a sanitised zone
                    around the Court Complex. For example, the secure
                    Marketplaces in NCR or around the State Assembly buildings.
                  </li>
                  <li>
                    High-Sensitivity Scanner to be deployed along the transition
                    points as mapped in the adjacency diagrams to control
                    movement of people between secure zones.
                  </li>
                </ul>
              </p>
              <p>
                Ideally, they should be automated with an alarm loud enough to
                attract attention of the security personnel around, but with an
                override to be used manually at a time of heightened threat
                perception.
              </p>
              <p>
                Plain Door Frame Metal Detector (“DFMD”) can be blended with
                room furniture for innocuous and passive security provisioning
                for VWDC and other sensitive areas. Similarly, portable DFMDs
                can be used during special times when heavy flow of people
                traffic is expected into the sanitised areas around court
                complex.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "3.",
          title: "Baggage Scanner",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[baggageScanner]}
              caption={"Image 116: Example of a Baggage Scanner"}
              creditLabel="Image Credit"
              imageCredit="RapiScan by Split Images"
              imageDescription={ImageDesc116}
            />
          ),
          functional: (
            <>
              <p>
                The Baggage screening System should be portable and non-bulky to
                facilitate usage in spaces within the Court Complex with
                space-constraints.
              </p>
              <p>
                It should be sensitive enough for identifying threats as well as
                capture images of each scan for records & checks post facto.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "4.",
          title: "Turnstile",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[turnStileImg]}
              caption={"Image 117: Example of a Turnstile"}
              creditLabel="Image Credit"
              imageCredit=" IndiaMART"
              imageDescription={ImageDesc117}
            />
          ),
          functional: (
            <>
              <p>
                Turnstiles are free flow barriers which can be operated by the
                end users based on access privileges and permissibility to enter
                the designated secure zone.
              </p>
              <p>
                These should have the facility to allow entry, avoid tailgating
                and generate people count to help ensure 100% evacuation during
                an emergency from the barricaded area.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "5.",
          title: "Bollards & Buried Vehicle Barriers",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[midDotImg]}
              caption={
                "Image 118: Example of a Bollard  & Burried Vehicle Barriers"
              }
              creditLabel="Image Credit"
              imageCredit="MidDot Automation - IndiaMART"
              imageDescription={ImageDesc118}
            />
          ),
          functional: (
            <>
              <p>
                The functional requirements of Bollards and Buried Vehicle
                Barriers are to ensure that unauthorised vehicles are not
                allowed movement in & out of the secured Court premises.
              </p>
              <p>
                The size and the material of these devices should be as per the
                aesthetic sensitivity of the Court Complex so as to ensure that
                it blends in with the rest of the design of the space.
              </p>
            </>
          ),
          essential: "Ideal",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "6.",
          title: "Mobile Sniffer",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[secureScanner]}
              caption={"Image 119: Example of a Mobile Sniffer"}
              creditLabel="Image Credit"
              imageCredit="SecurScan Security"
              imageDescription={ImageDesc119}
            />
          ),
          functional: (
            <>
              <p>
                A Mobile Sniffer is a futuristic system of sniffing explosive
                materials based on chemical signatures which mimics the natural
                ability of canines.
              </p>
              <p>
                It can be deployed during the time of heightened security needs
                with updated signatures.
              </p>
            </>
          ),
          essential: "Value Addition",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "3.2.",
          title: "Management Systems",
        },
        {
          sno: "1.",
          title: "Evacuation System",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[ipEmergency]}
              caption={
                "Image 120: Representation of an Emergency Communication & Evacuation System"
              }
              creditLabel="Image Credit"
              imageCredit="BARIX AG"
              imageDescription={ImageDesc120}
            />
          ),
          functional: (
            <>
              <p>
                The evacuation system should be planned to ensure an orderly and
                systematic evacuation of all stakeholders via designated routes
                to an open, pre-determined safe assembly area outside the
                complex or a refuge area in case of an enclosed multi-storied
                building.
              </p>
              <p>
                The evacuation system for a Court Complex should be simplified
                by factoring in the specific needs of three distinct
                stakeholders:
                {getCircleTypeListItemCustom(stakeholderItem, false)}
              </p>
              <p>
                However, the evacuation system has to be augmented with other
                safety systems like:
                {getCircleTypeListItemCustom(safetySystemItem, false)}
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "2.",
          title: "Parking Management System",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[parkingManagement]}
              caption={
                "Image 121: Representation of a Parking Management System"
              }
              creditLabel="Image Credit"
              imageCredit=" IndiaMART"
              imageDescription={ImageDesc121}
            />
          ),
          functional: (
            <>
              <p>
                The Parking Management System should be designed to automate or
                manage the flow of vehicular movement with tracking of entry &
                exit time and generate a bill for attendant payment or
                auto-debit of parking fees based on the access privileges
                available to the user.
              </p>
              <p>
                The system should be upgradable to an enhanced version based on
                automatic number plate recognition system, once the High
                Security Registration Plate (“HSRP”) numbering system gets
                adopted in large numbers.
              </p>
            </>
          ),
          essential: "Value Addition",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "3.",
          title: "Visitor Management System",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[visitorManagement]}
              caption={
                "Image 122: Representation of a Visitor Management System"
              }
              creditLabel="Image Credit"
              imageCredit="SmaSYS Sdn Bhd"
              imageDescription={ImageDesc122}
            />
          ),
          functional: (
            <>
              <p>
                The Visitor Management System has to be formulated to ensure
                that each visitor to the Court premises have been uniquely
                identified and accounted for.
              </p>
              <p>
                The system should track the ready data of the number of visitors
                on premise, to be checked in case of emergency evacuation
              </p>
            </>
          ),
          essential: "Ideal",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "4.",
          title: "Public Address System",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[publicAddressSystem]}
              caption={"Image 123: Schematic of a Public Address System"}
              creditLabel="Image Credit"
              imageCredit="BARIX AG"
              imageDescription={ImageDesc123}
            />
          ),
          functional: (
            <>
              <p>
                The Public Address System is an integral part of an evacuation
                system. Ideally each node/speaker of the system should be
                uniquely addressable for specific and contextual messages to the
                directed stakeholder.
              </p>
              <p>
                The Public Address System should be flexible to operate, both
                from the command-and-control system as well as give flexibility
                to operate via mobile/app based devices.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "5.",
          title: "Access Control System",
        },
        {
          sno: "a.",
          title: "Radio Frequency Identification (“RFID”)",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[rfid]}
              caption={"Image 124: Example of Machine for RFID Access Control"}
              creditLabel="Image Credit"
              imageCredit="AraTEK.co"
              imageDescription={ImageDesc124}
            />
          ),
          functional: (
            <>
              <p>
                An RFID is used to allow the entry of only authorised personnel
                in designated areas. It also has the ability to block the card
                temporarily (subject to administrative override) after
                repetitive failed attempts
              </p>
              <p>
                Non-Proprietary Technologies based on RFID/NFC would be ideal
                for use in Court Complexes to avoid vendor lock-in and
                prevention of migration to competing service providers.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "b.",
          title: "Biometric Fingerprint",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[biometricAccessControl]}
              caption={
                "Image 125: Example of Machine for Biometric Fingerprinting Access Control"
              }
              creditLabel="Image Credit"
              imageCredit="TekSun"
              imageDescription={ImageDesc125}
            />
          ),
          functional: (
            <>
              <p>
                The functional requirements of Biometric Fingerprinting is to
                ensure that only authorised personnel are allowed into secured
                private areas and prevention of forced entry either by proxy or
                tailgating.
              </p>
              <p>
                The system can auto block the device temporarily (subject to
                administrative override) after repetitive failed attempts but
                should have an option of number punch in case of need for
                emergency access.
              </p>
            </>
          ),
          essential: "Important",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "c.",
          title: "Integrated Review of Infrastructure for Safety (“IRIS”)",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[irisSourceSecurity]}
              caption={"Image 126: Example of Machine for IRIS Access Control"}
              creditLabel="Image Credit"
              imageCredit="Princeton Identity (SRI International)"
              imageDescription={ImageDesc126}
            />
          ),
          functional: (
            <>
              <p>
                IRIS is used to control the entry and exit of individuals within
                a designated area of the Court Complex. By this technology, it
                can be ensured that only authorised personnel enter certain
                designated areas or are prevented from exiting by impersonation.
              </p>
              <p>
                The size and the material of these devices should be as per the
                aesthetic sensitivity of the court complex so as to gel with the
                rest of the design and not look out of place to be consciously
                visible.
              </p>
            </>
          ),
          essential: "Value Addition",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "3.3.",
          title: "Security for Surveillance & Communication",
        },
        {
          sno: "1.",
          title: "IP Camera System with Video Analytics & Masking",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[leoSystem]}
              caption={"Image 127: Representation of a Video Management System"}
              creditLabel="Image Credit"
              imageCredit="Leo3 Systems"
              imageDescription={ImageDesc127}
            />
          ),
          functional: (
            <>
              <p>
                The IP Camera system should be based on open architecture, with
                an ability to integrate with legacy analog devices as well as
                support future proof systems such as Automatic Number-Plate
                Recognition (“ANPR”), Video Analytics, Facial Recognition, and
                Masking.
              </p>
              <p>
                The Video Management System proposed for such a system should be
                able to integrate with multi-party products and have flexible
                licensing mechanisms.
              </p>
              <p>
                It should be able to add triggers and generate alerts &
                notifications once the trigger conditions are met.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "2.",
          title: "Internet Protocol (“IP”) Surveillance System",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[survillenceSystem]}
              caption={"Image 128: Example of an IP Surveillance System"}
              creditLabel="Image Credit"
              imageCredit="ATS - A Total Solutions"
              imageDescription={ImageDesc128}
            />
          ),
          functional: (
            <>
              <p>
                The IP Surveillance system should be an all-weather system
                capable of recording in normal as well as exceptional mode in
                near dark condition. Thermal Cameras may be used in perimeter
                areas for intrusion detection.
              </p>
              <p>
                Ideally the Field of View should cover all areas of transit
                including and not limited to corridors, pathways and even
                elevators for accused.
              </p>
              <p>
                The Security Committee of the Court Complex should make
                provision for a Command and Control centre with a Quick Response
                Team, based on alerts and threats flagged by the system as part
                of the Security Policy.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "3.4.",
          title: "Digital Signage System/Mass Notification System",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <>
              <CaptionWithBorders1
                image={[notificationSystem]}
                caption={
                  "Image 129 : Example of Digital Mass Notification System for guiding emergency evacuation"
                }
                creditLabel="Image Credit"
                imageCredit="MCA Inc."
                imageDescription={ImageDesc129}
              />
              <CaptionWithBorders1
                image={[massNotificationImg]}
                caption={"Image 130: Example of a Mass Notification System"}
                creditLabel="Image Credit"
                imageCredit="Adgator"
                zoomImgStyle={{ height: "450px" }}
                imageDescription={ImageDesc130}
              />
            </>
          ),
          functional: (
            <>
              <p>
                The Digital Signage System should be multi-functional which
                would address diverse needs of the Court Complex from case
                listing to guidance messages during evacuation.
              </p>
              <p>
                Ideally the Mass Notification system should be IP addressable,
                allowing remote management and online notification.
              </p>
              <p>
                It should be synchronised with the Court Management System to
                allow specific and contextual messages on Display Boards which
                are in proximity to each Court.
              </p>
              <p>
                These are generally mass notification systems and avoid
                voice/sound as it disturbs a captive audience (in an enclosed
                area like waiting areas/lift lobbies or even outside court
                complexes). The system is generally equipped to have
                multi-lingual messaging and tickers/scrollers for contextual and
                attention grabbing time bound messages.
              </p>
            </>
          ),
          essential: "Ideal",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "3.5.",
          title: "Information Kiosks",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <>
              <CaptionWithBorders1
                image={[kioskImg]}
                caption={"Image 131: Example of an accessible information kiosk"}
                creditLabel="Image Credit"
                imageCredit="Adgators "
                imageDescription={ImageDesc131}
              />
              <CaptionWithBorders1
                image={[kioskImg2]}
                caption={
                  "Image 132: Example of a Mass Notification System and Accessible Interactive Self-Service Kiosks"
                }
                creditLabel="Image Credit"
                imageCredit="Adgators"
                imageDescription={ImageDesc132}
              />
            </>
          ),
          functional: (
            <>
              <p>
                Information Kiosks should be used throughout the Court Complex
                for addressing the information needs of specific individuals
                regarding their case details, ongoing proceedings in Courtrooms
                across the Court Complex, etc.
              </p>
              <p>
                Accessibility guidelines and standards in signage and kiosk
                placement must be taken into consideration.
              </p>
              <p>
                The system must display messages in multiple languages, have
                Text-to-Speech capability, braille integration, audio
                description for visual content, closed captioning for video
                content, audible alerts, high contrast display, and customizable
                font size and type.
              </p>
              <p>
                The Kiosk should also be equipped to provide real-time
                captioning for live events and provide accessible documents in
                alternative formats for Persons with Disabilities.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "3.6.",
          title: "Special Interventions",
        },
        {
          sno: "1.",
          title:
            "Server Room/Telecommunication Room/IP Camera Network Video Recorder (“NVR”) Room",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[dataRoomCompanyImg]}
              caption={"Image 133: Representative Image of a Server Room"}
              creditLabel="Image Credit"
              imageCredit="Data Room Company"
              imageDescription={ImageDesc133}
            />
          ),
          functional: (
            <>
              <p>
                A secure room must be designated as the Server Room with
                temperature-control provisions to accommodate all IT Services
                including and not limited to Networking, Data, IP Camera system
                including Video recording, Building Management system, etc.
              </p>
              <p>
                Ideally this room should have very restricted entry with logging
                of entry and exit.
              </p>
              <p>
                The data access to requisite subsystems within this room should
                be provided by software access.
              </p>
            </>
          ),
          essential: "Essential",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "2.",
          title: "Strong Room/Bunker",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[strongBunker]}
              caption={
                "Image 134: Representative Image of a Strong Room/Bunker"
              }
              creditLabel="Image Credit"
              imageCredit=" IpSec Group My"
              height={"300px"}
              imageDescription={ImageDesc134}
            />
          ),
          functional: (
            <>
              <p style={{ textAlign: "center" }}>
                A Strong Room/Bunker may be provided in the underground areas of
                high-risk vulnerable complexes for undertaking trials in high-ly
                sensitive cases. However, where such provisions are not
                available, video-conferencing facilities may be used to help
                mitigate the risk and need for such a requirement.
              </p>
            </>
          ),
          essential: "Ideal",
        },
      ],
    },
    {
      subHeading: [
        {
          sno: "3.",
          title: "Lead Protection System/Bullet Proof System",
        },
      ],
    },
    {
      data: [
        {
          pictorial: (
            <CaptionWithBorders1
              image={[breifCaseImg]}
              caption={"Image 135: Example of a Lead Protection System"}
              creditLabel="Image Credit"
              imageCredit="IndiaMART"
              imageDescription={ImageDesc135}
            />
          ),
          functional: (
            <>
              <p>
                Based on the threat perception of the Court Complex, a ballistic
                system could be provisioned to ensure the safe escort of the
                judiciary as well as risk mitigation for key
                witnesses/undertrials who may be vulnerable.
              </p>
              <p>
                This intervention may be decided by the Security Committee as
                needed and appropriate.
              </p>
            </>
          ),
          essential: "Value Addition",
        },
      ],
    },
  ];


  // process module tables array
  const securityModuleArr = [
    <ProcessModuleTable
      tableHeader={"PROCESS LITIGANTS"}
      tableData={litigantsTableData}
    />,
    <ProcessModuleTable
      tableHeader={"PROCESS JUDGE"}
      tableData={judgeTableData}
    />,
    <ProcessModuleTable
      tableHeader={"PROCESS ACCUSED"}
      tableData={accussedTableData}
    />,
    <ProcessModuleTable
      tableHeader={"PROCESS ADVOCATE"}
      tableData={advocateTableData}
    />,
    <ProcessModuleTable
      tableHeader={"PROCESS COURT OFFICIALS"}
      tableData={courtTableData}
    />,
    <ProcessModuleTable
      tableHeader={"PROCESS VWDC"}
      tableData={VWDCTableData}
    />,
  ];

  const courtStaffObject = {
    heading: "Court Staff",
    data: [
      "Registrar/Assistant Registrar",
      "Chief Administrative Officer",
      "Shirestedar",
      "Stenographers",
      "Bench Clerks",
      "Software Technicians",
      "Process Servers",
      "Bailiffs",
      "First Division Assistants (“FDA”)",
      "Second Division Assistants (“SDA”)",
      "Typists (Copyists)",
      "Attenders",
      "Peons",
      "Cleaners",
      "Drivers",
    ],
    isOrdered: true,
  };

  const shopkeeperObject = {
    heading: "4.2. Shopkeepers & Other Amenity Providers",
    data: [
      "Bookstalls and stationery shops (including lawyers’ accessories)",
      "Notary/Typist Services",
      "ATM and Bank Facilities Staff",
      "Photocopiers",
      "Stamp Vendors",
      "Oath Commissioners",
      "Food & Drink Stalls",
    ],
    isOrdered: true,
  };

  const architecturalObject = {
    data: [
      "The designing of the Court Complex should begin with a thoughtful spatial organisation that considers the placement and adjacencies of Courtrooms, waiting areas, and ancillary spaces.",

      "Shared walls between Courtrooms should be avoided to reduce sound transmission in cases where there are multiple Courtrooms in a single building. For example, non-acoustically sensitive spaces like store rooms can be planned in between courtrooms to ensure a buffer zone.",

      <>
        The public spaces must be strategically placed to prevent noise
        interference with Court proceedings.
        <br />
        <h3 id="FurnitureLayout" style={h3style}>
          <span style={{ fontSize: "20px" }}>5.1.</span>B. Courtroom Furniture
          and Layout:
        </h3>
      </>,
      "Furniture and seating arrangements that contribute to good acoustic conditions must be used. For example, fabric upholstery.",

      "The furniture must be positioned to facilitate clear communication among lawyers, litigants, Judges and other support persons during the proceedings. Ensure clear sight lines between all important participants.",
    ],
    isOrdered: true,
  };

  const designConsiderObject = [
    {
      icon: <img src={designConsideration} />,
      heading: "Design considerations",
      items: [
        "The area behind the judge's desk and the two side walls should be balanced with sound-reflecting and sound-absorbing surfaces. The wall surfaces should reflect signals towards the Judge, Bench Clerk, Accused Persons, Witnesses and other specialised persons such as interpreters or translators,  whenever an advocate speaks in that direction; but the ceiling should absorb sound to reduce its reflection, which can restrict the judge's ability to hear. Wooden/laminate panels and specific paint finishes may be considered for the back wall, and acoustic materials with 0.75 – 0.9 Noise Reduction Coefficient (“NRC”) shall be provided for the ceiling.",

        "Ceiling design in the Courtroom should be carefully studied. For example, if barrel-vaulted and coffered ceilings are used, the acoustical treatment would be inappropriate, as they can cause a fluttering echo or elongation of sound.",

        `The rear of the Courtroom is the area for the general public and should be treated as acoustically 
        "dead", with highly absorptive materials on the floors, walls, and ceiling.This will eliminate serious reverberation in the back, where most of the sound will be directed.Additionally, this will reduce the noise level generated by the spectators and witnesses seated in the public area. `,

        "Most Courtrooms that have hard benches, inclined at an angle, generate more reverberations. Upholstered seats could be considered to prevent uncontrollable reverberations in the room. Perforated/slotted wooden/laminated acoustic panels, fibre reinforced perforated gypsum may be considered for the wall treatment to achieve minimum 0.75 NRC.",

        <>
          Wherever possible floors in Courtrooms should be carpeted to prevent transmission of sound to the Courtroom below, as well as to absorb unwanted reflected sounds from the walls and ceilings.{reference(referenceData[2], 3)}
        </>
      ]
    },
    {
      heading: "Material recommendations",
      items: [
        <>
          Below are the recommendations for the acoustic properties of materials to be used in the Courtroom.

          <h3 style={{ paddingLeft: "15px" }}><i>I. Wall materials:</i></h3>
          <CaptionWithBorders1
            image={[renderCourtroom]}
            isZoom={true}
            caption={
              "Figure 77: Floorplan of a Courtroom with the layout for material recommendations for the Courtroom walls"
            }
            zoomImgStyle={{ height: "450px" }}
            imageDescription={FigureDesc77}
          />

          <h3 style={{ paddingLeft: "15px" }}><i>II. Ceiling materials: </i></h3>
          <CaptionWithBorders1
            image={[ceilingAccoustic]}
            isZoom={true}
            caption={
              "Figure 78: Floorplan of a Courtroom with the layout for material recommendations for the Courtroom ceiling"
            }
            zoomImgStyle={{ height: "450px" }}
            imageDescription={FigureDesc78}
          />

          <h3 style={{ paddingLeft: "15px" }}><i>III. Acoustic materials:</i></h3>
          <CaptionWithBorders1
            image={[slottedWooden, laminatedWooden]}
            isZoom={true}
            caption={
              "Image 137: Example of perforated wooden/laminate acoustic panel (left) and slotted wooden/laminated acoustic panel (right)"
            }
            creditLabel="Source"
            imageCredit="Topakaustic"
            zoomImgStyle={{ height: "450px" }}
            imageDescription={ImageDesc137}
          />

          {/* <CaptionWithBorders1
            image={[ceilingImg1, ceilingImg2]}
            isZoom={true}
            caption={
              "Image 138: Example of mineral fibre ceiling tiles (left) and perforated gypsum tile ceiling (right)"
            }
            creditLabel="Source"
            imageCredit="Amazone Ceiling and IndiaMart"
            imageDescription={ImageDesc138}
            zoomImgStyle={{ zoomImgWidth: (isXs) && "0px !important", isResponsive: (isXs && isSm) && "0px !important",width:"100%" }}
          /> */}

          <CaptionWithBorders2
            image={[{ imgSr: ceilingImg1, zoomImgWidth:isXs && "0px !important",isResponsive: (isXs && isSm) && "0px !important" }, { imgSr: ceilingImg2, height: "150px" }]}
            isZoom={true}
            caption={
              "Image 138: Example of mineral fibre ceiling tiles (left) and perforated gypsum tile ceiling (right)"
            }
            creditLabel="Source"
            imageCredit="Amazone Ceiling and IndiaMart"
            imageDescription={ImageDesc138}
            // zoomImgStyle={{ zoomImgWidth: (isXs) && "0px !important", isResponsive: (isXs && isSm) && "0px !important", width: "100%" }}
          />

          <CaptionWithBorders1
            image={[perforatedWall, ceilingTiles]}
            isZoom={true}
            caption={
              "Image 139: Example of fibre-reinforced perforated gypsum wall panelling (left) and perforated acoustic metal ceiling tiles (right)"
            }
            creditLabel="Source"
            imageCredit="Knauf Danoline and TVS Acoustics"
            zoomImgStyle={{ height: "450px" }}
            imageDescription={ImageDesc139}
          />
        </>,

        "The finishing material can be selected based on location, availability, maintenance etc., while ensuring that the required acoustic properties are met."
      ]
    },
  ]

  const environmentalObject = {
    data: [
      "Road and Air Traffic",

      "Metro and Railways",

      "Neighbouring industries",

      "Party Grounds/Convention Centres",

      "Event Spaces/Stadiums",

      "Windmill/Wind Noise (For example, in high range areas)",

      "Other environmental noises",
    ],
    isOrdered: false,
  };

  const recommendationsObject = {
    data: [
      "Planning the building façade to avoid noise intrusion. (For example, avoid windows and openings where high noises are expected.)",

      "Planning for the building compound wall/landscape elements to avoid noise transmission. (For example, trees, bushes and other landscaping elements may be used to block/diffuse noises to reduce the hindrance.)",

      "Planning the building openings/entrances/windows strategically to avoid noise transfer.",

      "Designing the façade using materials to mitigate environmental noise levels.",
    ],
    isOrdered: false,
  };

  const noiseObject = {
    data: [
      "HVAC Noises (Air flow noise, equipment noise)",

      "FAN Noises",

      "Cooler Noises",

      "Other electrical/network equipment ",
    ],
    isOrdered: false,
  };

  const mitigateListObject = {
    data: [
      "Plan the HVAC equipment strategically, i.e., noisy equipment must be placed away from sensitive areas, and low noise diffusers, duct lining and lagging materials must be used to reduce the noise.",

      "Low noise ceiling/wall fans must be used.",

      "High noise electrical/networking equipment must be placed away from sensitive zones.",

      "High noise areas must be isolated from the sensitive zones by planning other non-sensitive spaces next to them.",
    ],
    isOrdered: false,
  };

  const considerationsObject = {
    icon: <img src={designConsideration} />,
    heading: "Design considerations",
    data: [
      "All the penetrations in the acoustic partition/wall must be sealed acoustically.",

      <>
        Where sound insulation is a requirement, lightweight concrete blocks
        must not be used. dense concrete blocks{" "}
        <span style={dimensionStyle}>(1750 – 1950 kg/m3)</span> may be used
        depending on the sound transmission performance required.
      </>,

      "All partitions must be continued to the soffit of the floor slab and any holes or gaps filled. Perimeter gaps shall be filled by packing with dense mineral wool and finishing off with mortar or flexible building sealant.",

      "For the POSCO Court special considerations must be given to ensure the privacy of the victims. For example, architectural considerations like screens, planters, etc., can be used to achieve the same",
    ],
    isOrdered: true,
    isImage: true
  };

  const paraStyle = {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "27px",
    color: "#555555",
    letterSpacing: "0em",
    textAlign: "justified",
  };

  const pointStyle = {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "27px",
    color: "#555555",
    letterSpacing: "0em",
    textAlign: "justified",
    margin: "10px 30px",
  };

  const scrollToAccordion = (panelRef, panel) => {
    if (panelRef && panelRef.current) {
      panelRef.current.scrollIntoView({
        block: "center",
        inline: "center",
        behavior: "smooth",
      });
      setTimeout(() => {
        setExpanded(panel);
      }, 0);
    }
  };

  const scopeDetailObject = [
    <>
      Agreement for facility management contractor’s services prepared by the
      National Handloom Development Corporation Limited, Ministry of Textiles,
      Government of India.{reference(referenceData[7], 8)}
    </>,
    <>
      Request for proposal for selection of a facility management service
      provider for Paryavas Bhawan and its campus at Sector 19, Naya Raipur,
      prepared by the Naya Raipur Development Authority.
      {reference(referenceData[8], 9)}
    </>,
    <>
      Tender for facility management services at Rajiv Gandhi National Institute
      of Intellectual Property Management/Patent Information System
      (“RGNIIPM/PIS”), Nagpur prepared by the Government of India, Ministry of
      Commerce and Industry.{reference(referenceData[9], 10)}
    </>,
    <>
      Request for Proposals for selection of agency for providing comprehensive
      facility management services prepared by the Office of the District Judge,
      Rayagada, Odisha.{reference(referenceData[10], 11)}
    </>,
  ];

  const keyFeaturesObject = [
    "The application would feature comprehensive maps with detailed floor plans of the public areas of the Court Complex, allowing users to locate courtrooms, e-Seva Kendra, restrooms, elevators, and other essential facilities. ",

    "Real-time updates on Courtroom schedules, case statuses, and queue information will enable users to plan their visits effectively and manage their time efficiently.",

    "Accessibility features would be integrated to accommodate users with disabilities, such as visual impairments or mobility limitations. This could include options for high-contrast displays, voice-guided navigation, wheelchair-accessible routes, and auditory cues.",

    " In addition to navigation features, the application would integrate emergency protocols to guide users during evacuation procedures or critical situations within the Court Complex. ",

    "The app would feature virtual queue management, enabling users to join queues remotely and receive timely notifications, thus reducing congestion and wait times in the Court Complex, and improving the overall user experience.",

    "The app would provide language options and translation services for users requiring assistance in legal proceedings or speaking different languages.",

    "The app should prioritise collaboration with accessibility experts to ensure set standards of inclusivity for all users.",

    "The app would integrate with public transit, aiding users in planning travel to and from the Court Complex, and also offer details on nearby bus stops, train stations, parking, and accessible transportation options, ensuring seamless travel for all.",

    "The app would feature an interactive help desk for users to seek guidance from Court staff, and access legal resources, FAQs, and informational materials to empower users with knowledge about their rights and available services.",

    "The app would feature a robust feedback system for users to provide ratings, reviews, and suggestions, ensuring continuous improvement of functionality and user experience.",

    "It should also incorporate significant security measures, incorporating sophisticated protocols to safeguard sensitive information and ensure secure access to the application. This includes implementing multi-factor authentication, encryption, and regular security audits to protect user data and maintain privacy.",

    "The app may also feature integration of visitor check-in and arrival forms to facilitate registration and commencement of litigation case processing, or to display existing case data if already registered. ",
  ];

  return (
    <div>
      <Typography>
        <h1 id="handbookPrinciple" style={h1style}>
          PART E – ANNEXURES
        </h1>{" "}
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          className="annexure-btn-box"
        >
          <Button
            variant="outlined"
            className={`annexure-btn ${activeButton === "panel1Ref" ? "annexure-btn-active" : ""
              }`}
            onClick={() => {
              scrollToAccordion(panel1Ref, "panel1");
              setActiveButton("panel1Ref");
            }}
          >
            Annexure 1
          </Button>

          <Button
            variant="outlined"
            className={`annexure-btn ${activeButton === "panel2Ref" ? "annexure-btn-active" : ""
              }`}
            sx={{ margin: "10px" }}
            onClick={() => {
              setActiveButton("panel2Ref");
              scrollToAccordion(panel2Ref, "panel2");
            }}
          >
            Annexure 2
          </Button>

          <Button
            variant="outlined"
            className={`annexure-btn ${activeButton === "panel3Ref" ? "annexure-btn-active" : ""
              }`}
            onClick={() => {
              scrollToAccordion(panel3Ref, "panel3");
              setActiveButton("panel3Ref");
            }}
          >
            Annexure 3
          </Button>

          <Button
            variant="outlined"
            className={`annexure-btn ${activeButton === "panel4Ref" ? "annexure-btn-active" : ""
              }`}
            sx={{ margin: "10px" }}
            onClick={() => {
              scrollToAccordion(panel4Ref, "panel4");
              setActiveButton("panel4Ref");
            }}
          >
            Annexure 4
          </Button>

          <Button
            variant="outlined"
            className={`annexure-btn ${activeButton === "panel5Ref" ? "annexure-btn-active" : ""
              }`}
            onClick={() => {
              scrollToAccordion(panel5Ref, "panel5");
              setActiveButton("panel5Ref");
            }}
          >
            Annexure 5
          </Button>

          <Button
            variant="outlined"
            className={`annexure-btn ${activeButton === "panel6Ref" ? "annexure-btn-active" : ""
              }`}
            sx={{ marginLeft: "10px" }}
            onClick={() => {
              scrollToAccordion(panel6Ref, "panel6");
              setActiveButton("panel6Ref");
            }}
          >
            Annexure 6
          </Button>
          <Button
            variant="outlined"
            className={`annexure-btn ${activeButton === "panel7Ref" ? "annexure-btn-active" : ""
              }`}
            sx={{ marginLeft: "10px" }}
            onClick={() => {
              scrollToAccordion(panel7Ref, "panel7");
              setActiveButton("panel7Ref");
            }}
          >
            Annexure 7
          </Button>
          <Button
            variant="outlined"
            className={`annexure-btn ${activeButton === "panel8Ref" ? "annexure-btn-active" : ""
              }`}
            sx={{ marginLeft: "10px" }}
            onClick={() => {
              scrollToAccordion(panel8Ref, "panel8");
              setActiveButton("panel8Ref");
            }}
          >
            Annexure 8
          </Button>
          <Button
            variant="outlined"
            className={`annexure-btn ${activeButton === "panel9Ref" ? "annexure-btn-active" : ""
              }`}
            sx={{ marginLeft: "10px" }}
            onClick={() => {
              scrollToAccordion(panel9Ref, "panel9");
              setActiveButton("panel9Ref");
            }}
          >
            Annexure 9
          </Button>
        </Box>
        {/* annexure section one */}
        <Accordion
          className="accordion"
          ref={panel1Ref}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <CustomAccordionSummary
            expandIcon={
              expanded === "panel1" ? (
                <RemoveCircleOutlineIcon className="removeIcon" />
              ) : (
                <AddCircleOutlineIcon className="addIcon" />
              )
            }
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ margin: "0px !important" }}
            className="accordian-summary"
          >
            <h2 id="HeadingAnnexure1" className="annexure-heading">
              Annexure I: Sustainability Case Studies in the Indian Context
            </h2>
          </CustomAccordionSummary>
          <AccordionDetails className="accordian-details">
            <div style={{ margin: "30px 0" }}>
              <p className="table-guidance-heading">
                <span className="table-guidline-text">Table 22: </span>
                <br />
                <span style={tableCaption}>
                  Examples of sustainability case studies in India.{" "}
                </span>
              </p>
              <AnnexureTable
                isBold={true}
                tableHeader={annexureHeaderOne}
                rows={annexureRowOne}
              />
            </div>
          </AccordionDetails>
        </Accordion>
        {/* annexure section two */}
        <Accordion
          className="accordion"
          ref={panel2Ref}
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <CustomAccordionSummary
            expandIcon={
              expanded === "panel2" ? (
                <RemoveCircleOutlineIcon className="removeIcon" />
              ) : (
                <AddCircleOutlineIcon className="addIcon" />
              )
            }
            aria-controls="panel2-content"
            id="panel2-header"
            className="accordian-summary"
            sx={{
              "&.MuiAccordionSummary-contentGutters": {
                margin: "0px !important",
              },
              margin: "0px !important",
            }}
          >
            <h2 id="HeadingAnnexure2" className="annexure-heading">
              Annexure II: Overview of the building zones within the Court
              Complex
            </h2>
          </CustomAccordionSummary>
          <AccordionDetails className="accordian-details">
            <div style={{ margin: "30px 0" }}>
              <p className="table-guidance-heading">
                <span className="table-guidline-text">Table 23: </span>
                <br />
                <span style={tableCaption}>
                  Six building zones within the Court Complex.{" "}
                </span>
              </p>
              <AnnexureTable
                tableHeader={annexureHeaderTwo}
                rows={annexureRowTwo}
              />
            </div>
          </AccordionDetails>
        </Accordion>
        {/* annexure section three */}
        <Accordion
          className="accordion"
          ref={panel3Ref}
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <CustomAccordionSummary
            expandIcon={
              expanded === "panel3" ? (
                <RemoveCircleOutlineIcon className="removeIcon" />
              ) : (
                <AddCircleOutlineIcon className="addIcon" />
              )
            }
            aria-controls="panel3-content"
            id="panel3-header"
            className="accordian-summary"
          >
            <h2 id="HeadingAnnexure3" className="annexure-heading">
              Annexure III: Security Modules for Court Infrastructure
            </h2>
          </CustomAccordionSummary>
          <AccordionDetails className="accordian-details">
            <p style={paraStyle}>
              This section focuses on the multiple Security Systems and ICT
              needed for a Court Complex to ensure safety and wellbeing of all
              stakeholders. It is an attempt to list out all the different
              aspects of the enabling technological interventions which impact
              stakeholders, security locations and strategic IT & Security
              modules needed for a holistic approach for safety
            </p>
            <p style={paraStyle}>
              The different security systems which typically form the elements
              of a safety policy are detailed below. The systems and
              interventions identified have also been categorised into{" "}
              <span style={sectionStyle}>
                {" "}
                Essential, Important, Ideal and Value Addition
              </span>{" "}
              categories which can be chosen as required.
            </p>
            {/* physical security*/}
            <div style={{ margin: "30px 0" }}>
              <p className="table-guidance-heading">
                <span className="table-guidline-text">Table 24: </span>
                <br />
                <span style={tableCaption}>
                  {" "}
                  Security Systems to be implemented in the Court Complex.
                </span>
              </p>
              <SecurityModuleTable
                tableHeader={boomBarrierDataHeader}
                tableBody={boomBarrierData}
              />
            </div>
          </AccordionDetails>
        </Accordion>
        {/* annexure section four */}
        <Accordion
          className="accordion"
          ref={panel4Ref}
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <CustomAccordionSummary
            expandIcon={
              expanded === "panel4" ? (
                <RemoveCircleOutlineIcon className="removeIcon" />
              ) : (
                <AddCircleOutlineIcon className="addIcon" />
              )
            }
            aria-controls="panel4-content"
            id="panel4-header"
            className="accordian-summary"
          >
            <h2 id="HeadingAnnexure4" className="annexure-heading">
              Annexure IV: List of Court Staff Personnel and Vendors
            </h2>
          </CustomAccordionSummary>
          <AccordionDetails className="accordian-details">
            {getTextContentWithHeading(courtStaffObject)}
            {getTextContentWithHeading(shopkeeperObject)}
          </AccordionDetails>
        </Accordion>
        {/* annexure section five */}
        <Accordion
          className="accordion"
          expanded={expanded === "panel5"}
          onChange={handleChange("panel5")}
        >
          <CustomAccordionSummary
            expandIcon={
              expanded === "panel5" ? (
                <RemoveCircleOutlineIcon className="removeIcon" />
              ) : (
                <AddCircleOutlineIcon className="addIcon" />
              )
            }
            aria-controls="panel5-content"
            id="panel5-header"
            className="accordian-summary"
          >
            <h2
              id="HeadingAnnexure5"
              className="annexure-heading"
              ref={panel5Ref}
            >
              Annexure V: Design Considerations for Acoustics within the Court
              Complex
            </h2>
          </CustomAccordionSummary>
          <AccordionDetails className="accordian-details">
            <p style={paraStyle}>
              The acoustic design of Court Complexes plays a crucial role in
              upholding the integrity of the judicial process. Proper acoustic
              planning is essential to minimise noise disruptions, enhance
              communication, and ensure a conducive environment for legal
              proceedings. This section delves into key considerations and
              strategies for achieving effective acoustic design in Court
              Complexes across India.
            </p>
            <p style={paraStyle}>
              For a typical Courtroom, the litigation area is where the legal
              proceedings are undertaken and it should be audible to all the
              participants in the Courtroom. Therefore the litigation area is
              required to have moderate sound absorption and the audience area
              requires high sound absorption to avoid echo and noise buildup.
            </p>

            <h3 id="HeadingArchitecture" style={h3style}>
              <span style={{ fontSize: "20px" }}>5.1. </span>
              Architectural Considerations
            </h3>
            <h3 id="ArchitectureLayout" style={h3style}>
              <span style={{ fontSize: "20px" }}>5.1.</span>A. Spatial
              Organisation and Architectural Layout: Layout:
            </h3>

            {getTextContentWithHeading(architecturalObject)}

            {/* {getTextContentWithHeading(courtroomObject)} */}

            <h3 id="HeadingAcoustic" style={h3style}>
              <span style={{ fontSize: "20px" }}>5.2.</span> Acoustic
              Considerations
            </h3>
            <p style={paraStyle}>
              When conceptualising the interior of a Court Complex, attention
              must be given to acoustic considerations. The layout and design
              should incorporate sound-absorbing materials such as acoustic
              panels, carpets, and drapes to minimise reverberation and ensure
              clarity of speech. Strategic placement of these materials along
              with partitions within courtrooms, corridors, and waiting areas
              helps attenuate noise levels and maintain confidentiality during
              proceedings. The following section delves into the acoustic
              parameters and provides recommendations for the different spaces
              within a Court Complex.
            </p>

            <h3 id="reverberation" style={h3style}>
              <span style={{ fontSize: "20px" }}>5.2.</span>A. Reverberation
              Time (RT60)
            </h3>
            <p style={paraStyle}>
              The need to limit the short reverberation time in a Court Complex
              is critical to preserve speech intelligibility. The reverberation
              time target for the Courtroom and associated public areas must be
              determined using the figure below:
            </p>

            <CaptionWithBorders1
              image={[spaceVolume]}
              caption={
                "Image 136: Reverberation time target in relation to Space volume"
              }
              creditLabel="Source"
              imageCredit="DIN 18041, Figure 3"
              imageDescription={ImageDesc136}
            />

            <p style={paraStyle}>
              The graph A2 in the figure above should be referred for the
              Courtroom and all associated spaces where the primary importance
              is given to speech audibility.{reference(referenceData[1], 2)}
            </p>

            {subHeadingContent(designConsiderObject)}

            <h3 id="reverberation" style={h3style}>
              <span style={{ fontSize: "20px" }}>5.2.</span>B. Background Noise
              Level
            </h3>

            <p style={paraStyle}>
              The background noise level shall be maintained in the courtroom
              and associated spaces to ensure speech intelligibility in the
              space. The background noise level is the totality of all sounds
              within the room when the space is unoccupied and all the services
              are running as normal. The below diagram illustrates a few most
              common sources of noises.
            </p>

            <CaptionWithBorders1
              image={[sourceOfNoise]}
              caption={"Image 140: Examples of common sources of noise"}
              creditLabel="Source"
              imageCredit="Union Acoustics"
              zoomImgStyle={{ height: "300px" }}
              imageDescription={ImageDesc140}
            />

            <p style={paraStyle}>
              The acceptable noise level in the Courtroom and associated spaces
              shall be derived from the National Building Code and the American
              Society of Heating, Refrigerating and Air-Conditioning Engineers
              (“ASHRAE”), for the Courtroom Noise Criterion (“NC”) 30 (35 dBA)
              must be achieved to avoid any disturbances.
              {reference(referenceData[3], 4)}
            </p>
            <p style={paraStyle}>
              The following considerations must be taken into account to achieve
              the noise level requirements:
            </p>

            <h3 id="enviornmentalOffice">
              <i>I. Environmental Noise</i>
            </h3>

            <p style={paraStyle}>
              The environmental noise must be taken into consideration in the
              early stages of the planning process. Road and air-traffic noise
              must be studied before planning the building to ensure the noise
              generated will not disturb the Court Complex functions. The
              building façade, orientation, and shapes must be planned to avoid
              these noises travelling into the building.
            </p>
            <p style={paraStyle}>
              During the initial planning of the building, the designer should
              be mindful of the following major sources of noises that might be
              generated in the vicinity of the site:
            </p>

            {getTextContentWithHeading(environmentalObject)}

            <p style={paraStyle}>
              The following recommendations may be taken into consideration to
              mitigate the effects of these noise sources:
            </p>
            {getTextContentWithHeading(recommendationsObject)}

            <h3 id="mechancalService">
              <i>II. Mechanical services Noise</i>
            </h3>

            <p style={paraStyle}>
              All the building services within the Court Complex must be
              designed to achieve the background noise levels as derived from
              the standard guidelines.{reference(referenceData[4], 5)}
            </p>

            <div style={{ margin: "30px 0" }}>
              <p className="table-guidance-heading">
                <span className="table-guidline-text">Table 26: </span>
                <br />
                <span style={tableCaption}>
                  Recommended noise levels within various spaces in the Court
                  Complex
                </span>
              </p>
              <CustomTable tableData={mechanicalNoiseTable} />
            </div>

            <p style={paraStyle}>
              Below are the sources and mitigations for possible mechanical
              services noises in the building:
            </p>
            {getTextContentWithHeading(noiseObject)}
            <p style={paraStyle}>
              The following are the recommendations to mitigate these noise
              levels:
            </p>
            {getTextContentWithHeading(mitigateListObject)}

            <p style={paraStyle}>
              While the above recommendations are generic, each Courtroom may
              possess certain unique challenges based on the location and other
              parameters, therefore all the possible noise sources must be
              carefully studied to avoid any noise problems in the future.
            </p>

            <h3 id="airBorne" style={h3style}>
              <span style={{ fontSize: "20px" }}>5.2.</span>C. Air-borne Noise
              Isolation
            </h3>

            <p style={paraStyle}>
              To achieve the required level of privacy between different areas
              of a court, it is essential that the intervening wall and floor
              constructions provide sufficient levels of airborne sound
              insulation. The following table represents the recommended
              isolation value for different spaces in a Court Complex.
              {reference(referenceData[5], 6)}
            </p>

            <div style={{ margin: "30px 0" }}>
              <p className="table-guidance-heading">
                <span className="table-guidline-text">Table 27: </span>
                <br />
                <span style={tableCaption}>
                  Recommended isolation value for different spaces within the
                  Court Complex.
                </span>
              </p>
              <CustomTable tableData={airNoiseTable} />
            </div>

            <h3 id="walls">
              <i>I. Walls</i>
            </h3>

            <p style={paraStyle}>
              The sound insulation requirement of each partition should be
              assessed for each room/space based on the adjacent area and the
              location. The following table represents different construction
              materials and their STC values. Ideal materials can be selected as
              per the specific location requirements.
              {reference(referenceData[6], 7)}
            </p>

            <div style={{ margin: "30px 0" }}>
              <p className="table-guidance-heading">
                <span className="table-guidline-text">Table 28: </span>
                <br />
                <span style={tableCaption}>
                  Construction materials that may be used depending on the STC
                  values.
                </span>
              </p>
              <CustomTable tableData={wallsTable} />
            </div>

            {getTextContentWithHeading(considerationsObject)}

            <h3 id="doors">
              <i>II. Doors</i>
            </h3>

            <p style={paraStyle}>
              For all the acoustically sensitive spaces, acoustic doors shall be
              provided, which will avoid any noise leakages to the adjacent
              area. STC 45 rated doors are recommended for the courtrooms and
              other sensitive areas, the need of the acoustic doors can be
              eliminated by providing a lobby to lock the sound travel. The
              doors shall be solid timber door having, minimum{" "}
              <span style={dimensionStyle}>75mm</span> thick/ acoustic door{" "}
              <span style={dimensionStyle}>50</span> to{" "}
              <span style={dimensionStyle}>75mm</span> thick with a rebated
              frame and acoustic seals all around.
            </p>

            <h3 id="audioSystem" style={h3style}>
              <span style={{ fontSize: "20px" }}>5.2.</span>D. Audio System
              Intelligibility
            </h3>

            <p style={paraStyle}>
              Where audio systems are used to enhance intelligibility in
              Courtrooms, they must achieve a minimum Speech Transmission Index
              (“STI”) value of <span style={dimensionStyle}>0.6</span> in all
              coverage zones. The design of speech reinforcement systems to
              achieve particular STI values is a specialised subject and shall
              be carried out only by an acoustic consultant or public address
              system designer.
            </p>
          </AccordionDetails>
        </Accordion>
        {/* annexure section six */}
        <Accordion
          className="accordion"
          expanded={expanded === "panel6"}
          onChange={handleChange("panel6")}
        >
          <CustomAccordionSummary
            expandIcon={
              expanded === "panel6" ? (
                <RemoveCircleOutlineIcon className="removeIcon" />
              ) : (
                <AddCircleOutlineIcon className="addIcon" />
              )
            }
            aria-controls="panel6-content"
            id="panel6-header"
            className="accordian-summary"
          >
            <h2
              id="HeadingAnnexure6"
              className="annexure-heading"
              ref={panel6Ref}
            >
              Annexure VI: Comprehensive List of Accessibility Measures
            </h2>
          </CustomAccordionSummary>
          <AccordionDetails className="accordian-details">
            <p style={paraStyle}>
              Accessibility stands as a cornerstone of justice. In the pursuit
              of upholding principles of equality and justice within the legal
              system, it becomes imperative to ensure that every person has
              unimpeded access to the Courts. This annexure serves as an
              essential resource, offering a comprehensive list of spaces and
              tools designed to accommodate persons with diverse disabilities
              (visible, invisible and temporary) in the context of the District
              Court Complex. This is provided as a ready reckoner, in addition
              to the space-by-space recommendations provided in the Design
              Handbook.
            </p>
            <p style={paraStyle}>
              Apart from facilitating physical access, this annexure also
              underscores the importance of providing technological solutions
              such as assistive devices and digital accessibility features.
              Further, it highlights the significance of sensitivity training
              for Court staff to ensure effective communication and support for
              persons with disabilities.
            </p>

            <p style={paraStyle}>
              Prioritising accessibility ensures legal compliance and cultivates
              an inclusive environment that respects the diverse needs of all
              court users, affirming the commitment to equitable access to
              justice for all.
            </p>

            <p style={paraStyle}>
              List of accessible spaces and associated tools:
            </p>

            {getTextNestedList(associatedTools)}
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="accordion"
          expanded={expanded === "panel7"}
          onChange={handleChange("panel7")}
        >
          <CustomAccordionSummary
            expandIcon={
              expanded === "panel7" ? (
                <RemoveCircleOutlineIcon className="removeIcon" />
              ) : (
                <AddCircleOutlineIcon className="addIcon" />
              )
            }
            aria-controls="panel7-content"
            id="panel7-header"
            className="accordian-summary"
          >
            <h2
              id="HeadingAnnexure7"
              className="annexure-heading"
              ref={panel7Ref}
            >
              Annexure VII: Relevant Sustainable Development Goals Adopted in
              the Handbook
            </h2>
          </CustomAccordionSummary>
          <AccordionDetails className="accordian-details">
            <p style={paraStyle}>
              The following table outlines the relevant SDGs being addressed
              along with the specific Targets:
            </p>

            <div style={{ margin: "30px 0" }}>
              <p className="table-guidance-heading">
                <span className="table-guidline-text">Table 29: </span>
                <br />
                <span style={tableCaption}>
                  Relevant design considerations provided for Sustainable
                  Development Goals
                </span>
              </p>
              <AnnexureSevenTable tableData={annexureSevenData} />
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="accordion"
          expanded={expanded === "panel8"}
          onChange={handleChange("panel8")}
        >
          <CustomAccordionSummary
            expandIcon={
              expanded === "panel8" ? (
                <RemoveCircleOutlineIcon className="removeIcon" />
              ) : (
                <AddCircleOutlineIcon className="addIcon" />
              )
            }
            aria-controls="panel8-content"
            id="panel8-header"
            className="accordian-summary"
          >
            <h2
              id="HeadingAnnexure8"
              className="annexure-heading"
              ref={panel8Ref}
            >
              Annexure VIII: Examples of Scope of Work of Facilities Management
              Services
            </h2>
          </CustomAccordionSummary>
          <AccordionDetails className="accordian-details">
            <h3 id="reverberation" style={h3style}>
              <span style={{ fontSize: "20px" }}>8.1.</span> For Court Complexes
              that are already in use:
            </h3>
            <p style={paraStyle}>
              Several Requests for Proposals (“RFPs”) and contractual agreements
              are available for reference where the scope of work covers aspects
              ranging from site level management to servicing of building
              facilities. The following may be referred to for examples of
              detailed scope of work:
              {/* change ref no */}
            </p>
            {generateOrderedList(scopeDetailObject)}

            <h3 id="reverberation" style={h3style}>
              <span style={{ fontSize: "20px" }}>8.2.</span> For new or under
              construction Court buildings:
            </h3>

            <p style={paraStyle}>
              A good example that may be referred to is the Request for
              Proposal, OSDC 2.0 - Extension of Odisha State Data Centre, 2021,
              prepared by the Technical Directorate of E&IT Department,
              Government of Odisha.{reference(referenceData[11], 12)} The RFP
              provides components of planning and design where the minimum
              specified scope of work to be undertaken by the bidder is for
              designing, building, supplying, installation, and commissioning
              along with operations and maintenance of technical services and
              soft services. The RFP also provides indicative floor plans with
              furniture layouts and specifications for internal elements
              including environmentally friendly and ergonomic furniture.
            </p>

            <p style={paraStyle}>
              Currently, the Orissa High Court has also established a Judicial
              Infrastructure Management Agency (“JIMA”) as a dedicated Division
              Division established by the State government in consultation with
              the High Court in Odisha in 2022 for the management of judicial
              infrastructure is a significant, path-breaking initiative worth
              emulating. The JIMA, comprising Engineers and Architects, manages
              the construction and maintenance of all judicial infrastructure of
              the State. It serves as a Nodal Agency that monitors the physical
              and financial status of all state judiciary infrastructure
              projects. Its primary functions include overseeing project
              preparation, drawing and design, architecture, procurement, award
              of contracts, supervising the engineering and construction for new
              projects, and handling maintenance and renovation of existing
              projects, including annual maintenance contracts.
              {reference(referenceData[12], 13)}
            </p>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="accordion"
          expanded={expanded === "panel9"}
          onChange={handleChange("panel9")}
        >
          <CustomAccordionSummary
            expandIcon={
              expanded === "panel9" ? (
                <RemoveCircleOutlineIcon className="removeIcon" />
              ) : (
                <AddCircleOutlineIcon className="addIcon" />
              )
            }
            aria-controls="panel9-content"
            id="panel9-header"
            className="accordian-summary"
          >
            <h2
              id="HeadingAnnexure9"
              className="annexure-heading"
              ref={panel9Ref}
            >
              Annexure IX: Accessibility App
            </h2>
          </CustomAccordionSummary>
          <AccordionDetails className="accordian-details">
            <p style={paraStyle}>
              The outlined key features and indicative development process are
              objectively intended for the concerned Court officials and the app
              developers (who would be officially designated through the formal
              process) to provide a foundational understanding of the essential
              frameworks required for app development. The development process
              must align with subjectively relevant parameters and the
              availability of necessary resources.
            </p>

            <h3 id="keyFeatures" style={h3style}>
              <span style={{ fontSize: "20px" }}>9.1.</span> Key Features
            </h3>

            {generateOrderedList(keyFeaturesObject)}

            <CaptionWithBorders1
              image={[annexure9Img]}
              caption={
                "Image 141: Emergency Messaging and Alerts for digital signage"
              }
              creditLabel="Source"
              imageCredit="https://www.pickcel.com/blog/courtroom-digital-signage/"
              zoomImgStyle={{ height: "500px" }}
              imageDescription={ImageDesc141}
            />

            <h3 id="applicationDevelopment" style={h3style}>
              <span style={{ fontSize: "20px" }}>9.2.</span> Indicative Process
              of Application Development
            </h3>

            <p style={paraStyle}>
              The development process of the application should be
              contextualised, with careful consideration of the specific user
              requirements and available essential resources. The following are
              the indicative steps prescribed to be followed for developing the
              app for a particular District Court:
            </p>

            {orderedListWithItem(applicationDev)}
          </AccordionDetails>
        </Accordion>
        <h2 ref={referencesRef} id="annexureRef" style={referenceStyle}>
          References
          <Divider />
        </h2>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
};

export default AnnexureReading;
